import {App} from '@capacitor/app';
import {PushNotifications} from '@capacitor/push-notifications';

// Stable adapter methods also allow browser tests to replace native Capacitor proxies.
export const pushPlatform = {
  checkPermissions: () => PushNotifications.checkPermissions(),
  requestPermissions: () => PushNotifications.requestPermissions(),
  register: () => PushNotifications.register(),
  addListener: PushNotifications.addListener.bind(PushNotifications),
  addAppListener: App.addListener.bind(App),
};
